import { apiClient } from '@/shared/api';
import type {
  SampleCreateRequest,
  SampleCreateResponse,
  SampleListParams,
  SampleListResponse,
  SampleResponse,
  SampleUpdateRequest,
  SampleUpdateResponse,
} from './types';

// Re-export types for convenience
export type {
  SampleCreateRequest,
  SampleCreateResponse,
  SampleListItem,
  SampleListParams,
  SampleListResponse,
  SampleResponse,
  SampleUpdateRequest,
  SampleUpdateResponse,
} from './types';

/**
 * Fetch a list of samples per GET /sample
 */
export const fetchSamples = async (params?: SampleListParams): Promise<SampleListResponse> => {
  const { data } = await apiClient.get<SampleListResponse>('/sample', { params });
  return data;
};

/**
 * Fetch a sample by ID per GET /sample/{id}
 */
export const fetchSample = async (id: number | string): Promise<SampleResponse> => {
  const { data } = await apiClient.get<SampleResponse>(`/sample/${id}`);
  return data;
};

/**
 * Create a sample per POST /sample
 */
export const createSample = async (payload: SampleCreateRequest): Promise<SampleCreateResponse> => {
  const { data } = await apiClient.post<SampleCreateResponse>('/sample', payload);
  return data;
};

/**
 * Update a sample per PUT /sample/{id}
 */
export const updateSample = async (
  id: number | string,
  payload: SampleUpdateRequest,
): Promise<SampleUpdateResponse> => {
  const { data } = await apiClient.put<SampleUpdateResponse>(`/sample/${id}`, payload);
  return data;
};

/**
 * Delete a sample per DELETE /sample/{id}
 */
export const deleteSample = async (id: number | string): Promise<void> => {
  await apiClient.delete(`/sample/${id}`);
};
